import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { createBrowserHistory } from 'history';
import { I18nextProvider } from 'react-i18next';
import { makeReducer } from 'reducers';
import { routerMiddleware, ConnectedRouter } from 'connected-react-router';
import { setTopBarVisibility } from 'actions/shellActions';
import { serverDetailsRequest } from 'actions/serverActions';
import { registerSagas, unhandledErrorHandler, loadLanguageFile, processSpecialRoutes } from 'startup';
import sagas from 'sagas';
import { App } from 'ui/main/App';

// TODO? import registerServiceWorker from './registerServiceWorker';
import { composeWithDevTools } from 'redux-devtools-extension';

import './index.css';

const sagaMiddleware = createSagaMiddleware();

const history = createBrowserHistory();

// TODO: strip out dev tools in production
const store = createStore(
    makeReducer(history),
    composeWithDevTools(
        applyMiddleware(
            sagaMiddleware,
            routerMiddleware(history),
        )
    )
);

// Register to catch unhandled errors
unhandledErrorHandler.register(window, store.dispatch);

registerSagas(sagas as any, sagaMiddleware);

// Hide the top bar if necessary (e.g. being embedded within the desktop client)
if (/embedded=1/.test(window.location.search)) {
    store.dispatch(setTopBarVisibility(false));
}

// Did we come from a special external URL (e.g. Alarm Email, ServerConfig, etc)
processSpecialRoutes(window.location.search, store);

// Load the current language and signal when it's done
const i18n = loadLanguageFile(store);

// Get timezone information from the server
store.dispatch(serverDetailsRequest());


// Begin rendering React components
ReactDOM.render(
    <Provider store={ store as any }>
        <I18nextProvider i18n={ i18n }>
            <ConnectedRouter history={ history }>
                <App />
            </ConnectedRouter>
        </I18nextProvider>
    </Provider>,
    document.getElementById('root') as HTMLElement
);

// TODO? registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx